(function () {
  function init() {
    var sticky=document.querySelector('[data-pp-sticky]');
    var intro=document.getElementById('product-intro');
    var offer=document.getElementById('offers');
    var footer=document.querySelector('footer');
    var purchaseButtons=Array.from(document.querySelectorAll('[data-hero-atc],[data-bbp-atc],form[id^="hero-form-"] button[type="submit"]'));
    if (!sticky || !intro || !offer) return;
    var ticking=false;
    function update() {
      ticking=false;
      var anyPurchaseVisible=purchaseButtons.some(function (button) {var r=button.getBoundingClientRect();return r.height>0 && r.top<innerHeight && r.bottom>0;});
      var offerRect=offer.getBoundingClientRect();
      var viewingOffer=offerRect.top<innerHeight && offerRect.bottom>0;
      var atFooter=footer && footer.getBoundingClientRect().top<innerHeight;
      var show=intro.getBoundingClientRect().top<0 && !viewingOffer && !anyPurchaseVisible && !atFooter;
      sticky.hidden=!show;
      document.body.style.paddingBottom=show?sticky.offsetHeight+'px':'';
    }
    function queue() {if(!ticking){ticking=true;requestAnimationFrame(update);}}
    addEventListener('scroll',queue,{passive:true});
    addEventListener('resize',queue);
    addEventListener('hashchange',queue);
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
